<template>
<div>
  <div class="intro">
    <h1>人際風格問卷</h1>
    <h1> Social Style Inventory</h1>
  </div>
  <div class="survey" v-if="!finished">
    <p>問卷一共有18題，請在每一題內，選擇最適合你的一個選項。</p>
    <div class="question" v-for="(q, index) in questions" :key="index">
    <p class="qno">Question {{q.number}}</p>
    <div class="description">
      <label class="container">{{q.a}}
        <input type="radio" :name="q.number" value="a" v-model="q.value">
        <span class="checkmark"></span>
      </label>
      <!-- <vs-radio v-model="q.value" vs-value="a"></vs-radio>{{q.a}} -->
    </div>
    <div class="description">
      <!-- <vs-radio v-model="q.value" vs-value="b"></vs-radio>{{q.b}} -->
      <label class="container">{{q.b}}
        <input type="radio" :name="q.number" value="b" v-model="q.value">
        <span class="checkmark"></span>
      </label>
    </div>
    </div>
    <div class="submit">
      <p style="color: red;" v-if="incomplete">請先完成所有題目! 尚餘題目 {{this.incompleteQs}} 未回答!</p>
      <vs-button color="success" type="relief" @click="submitForm">Submit 提交</vs-button>
    </div>
  </div>
  <div class="results" v-if="type == 'RA'">
    <vs-divider/>
    <h2>你的性格是 RA - 推動型</h2>
      <ul>
        <li><h2>推動型的朋友期望</h2></li>
        <li>擁有主權及自由處事</li>
        <li>事情在探索之內，能影響別人及事情</li>
        <li>步伐快速</li>
        <li>講求事實、但無須太仔細</li>
        <li>能取勝</li>
        <li>作帶領</li>
        <li>能掌握別人的立場</li>
        <li>對自己立場肯定，不易受人影響</li>
      </ul>
  </div>
    <div class="results" v-if="type == 'RB'">
    <vs-divider/>
    <h2>你的性格是 RB - 表達型</h2>
      <ul>
        <li><h2>表達型的朋友期望</h2></li>
        <li>能刺激別人的思維</li>
        <li>得到別人的肯定與認同</li>
        <li>能表現友善的態度</li>
        <li>能參與作決定的過程中</li>
        <li>與思想積極、樂觀的人合作</li>
        <li>處事以不規律的方式</li>
        <li>接受有挑戰性的任務</li>
        <li>不著眼於事情的細微之處</li>
        <li>作決定及行動也非常迅速</li>
      </ul>
  </div>
    <div class="results" v-if="type == 'LA'">
    <vs-divider/>
    <h2>你的性格是 LA - 分析型</h2>
      <ul>
        <li><h2>分析型的朋友期望</h2></li>
        <li>做事要有準則</li>
        <li>需要事實和証明</li>
        <li>要有清晰指示</li>
        <li>會避免冒險和犯錯</li>
        <li>追求準確，合理解釋</li>
        <li>要有安全感和肯定才做決定</li>
        <li>遁序漸進,重視事工</li>
        <li>期待有支持和低調的讚賞</li>
        <li>深思熟慮</li>
      </ul>
  </div>
    <div class="results" v-if="type == 'LB'">
      <vs-divider/>
      <h2>你的性格是 LB - 隨和型</h2>
        <ul>
          <li><h2>隨和型的朋友期望</h2></li>
          <li>建立和維繫人與人的關係</li>
          <li>需要安全感</li>
          <li>被人所接納</li>
          <li>對事情需要有心理準備</li>
          <li>期待成為群體的一份子</li>
          <li>需要有時間和空間去思考和適應</li>
          <li>需要別人欣賞</li>
          <li>不愛單獨行事</li>
          <li>逃避衝突</li>
          <li>寧願維持現狀</li>
          <li>討人歡喜</li>
          <li>不能爽快做決定</li>
          <li>慢熱,需要時間去向別人流露自己</li>
        </ul>
  </div>
</div>

</template>

<script>
import { db } from '../main';

export default {
  name: 'Questions',
  data () {
    return {
      questions:
      [
        {"number": 1,"value": "0","mode": "BA","a": "較多手勢 More gestures","b": "較少手勢 Fewer gestures"},
        {"number": 2,"value": "0","mode": "LR","a": "說話較溫柔 Speaks more softly","b": "說話較大聲 Speaks more loudly"},
        {"number": 3,"value": "0","mode": "BA","a": "自由, 較多身體動作 Freer, more flowing body movement","b": "較控制身體動作 More controlled body movement"},
        {"number": 4,"value": "0","mode": "LR","a": "說話較慢 Speaks more slowly","b": "說話較快 Speaks more rapidly"},
        {"number": 5,"value": "0","mode": "BA","a": "較多面部表情 More animated facial expression","b": "較少面部表情 Less facial expression"},
        {"number": 6,"value": "0","mode": "LR","a": "手勢及身體動作較慢  Slower gestures and body movement","b": "手勢及身體動作較快 Faster gestures and body movement"},
        {"number": 7,"value": "0","mode": "BA","a": "較多語調變化 More vocal variation (intonation, etc.)","b": "較少語調變化 Less vocal variation (intonation, etc.)"},
        {"number": 8,"value": "0","mode": "LR","a": "交談時身體微向後趟 Tend to lean backward in conversations","b": "交談時身體微向前傾 Tend to lean forward when talking"},
        {"number": 9,"value": "0","mode": "BA","a": "對時間觀念比較放鬆 More flexible about time","b": "對時間控制非常嚴謹 More discipline about time (i.e. be punctual)"},
        {"number": 10,"value": "0","mode": "LR","a": "表達事實及意見比較暫時性，不敢肯定 Expresses facts and opinions more tentatively","b": "表達事實及意見非常忠肯，比較絕對 Expresses facts and opinions more strongly"},
        {"number": 11,"value": "0","mode": "BA","a": "處事以人為中心 More people-oriented","b": "處事以事為中心 More task-oriented"},
        {"number": 12,"value": "0","mode": "LR","a": "作決定比較慢 Decides more slowly","b": "作決定比較快 Decides more quickly"},
        {"number": 13,"value": "0","mode": "BA","a": "表現較挑皮和開朗 Appears to be more playful and fun-loving","b": "表現較嚴肅 Appears to be more serious"},
        {"number": 14,"value": "0","mode": "LR","a": "少作冒險挑戰性的事情 Takes fewer chances; is less risk-oriented","b": "不怕冒險，把握機會接受挑戰 Takes more chances; is more risk-oriented"},
        {"number": 15,"value": "0","mode": "BA","a": "決定事情基於個人感受或意見 Decisions based more on feelings or opinions","b": "決定事情基於事實或結果 Decisions based more on facts or results"},
        {"number": 16,"value": "0","mode": "LR","a": "很少對人施以壓力來作決定 Exerts less pressure for decision","b": "對人施加壓力以便作出決定 Exerts more pressure for decision"},
        {"number": 17,"value": "0","mode": "BA","a": "較少眼神接觸 Less eye contact","b": "較多眼神接觸 More eye contact"},
        {"number": 18,"value": "0","mode": "LR","a": "較容易與人分享個人經歷及感受 More apt to tell stories and show feelings","b": "較少與人分享個人故事和感受 Less apt to tell stories and show feelings"}
      ],
      finished: false,
      type: null,
      incompleteQs: [],
      incomplete: false
    }
  },
  methods: {
    submitForm: function() {
      var instance = this;
      var A = 0; var B = 0; var L = 0; var R = 0;
      this.incomplete = false;
      this.incompleteQs = [];
      var stop = false;
      var stopQs = [];

      this.questions.forEach((q, index, array) => {
        if (q.value == "0") {
          stop = true;
          stopQs.push(q.number);
        }
      })

      if (stop) {
        this.incomplete = true;
        this.incompleteQs = stopQs;
        this.$vs.loading.close();
        return;
      }

      this.finished = true;
      this.$vs.loading({type:'radius'});

      this.questions.forEach((q, index, array) => {
        if (q.mode == "BA") {
          if (q.value == "a") {
            B++;
          }
          if (q.value == "b") {
            A++;
          }
        }
        if (q.mode == "LR") {
          if (q.value == "a") {
            L++;
          }
          if (q.value == "b") {
            R++;
          }
        }
      })
      console.log(A, B, L, R);
      var RA = R*A;
      var RB = R*B;
      var LA = L*A;
      var LB = L*B;
      console.log (RA, RB, LA, LB);

      let personality = [{name: "RA", value: RA}, {name: "RB", value: RB}, {name: "LA", value: LA}, {name: "LB", value: LB}];
      personality.sort((a, b) => {
        if (a.value > b.value) return -1;
        if (b.value > a.value) return 1;
        return 0;
      })

      console.log(personality[0]);
      var rtDocRef = db.collection("realtime-results").doc("9ZJbaU1hzDo08wNcGBfc");
      db.runTransaction(function(transaction) {
        return transaction.get(rtDocRef).then(function(rtDoc) {
          if (!rtDoc.exists) {
            throw "Cloud Firestore Data Corrupted, Please check the database"
          }

          switch (personality[0].name) {
            case "RA": 
            var newRA = rtDoc.data().RA + 1;
            transaction.update(rtDocRef, {RA: newRA});
            break;
            case "RB": 
            var newRB = rtDoc.data().RB + 1;
            transaction.update(rtDocRef, {RB: newRB});
            break;              
            case "LA": 
            var newLA = rtDoc.data().LA + 1;
            transaction.update(rtDocRef, {LA: newLA});
            break;              
            case "LB": 
            var newLB = rtDoc.data().LB + 1;
            transaction.update(rtDocRef, {LA: newLB});
            break;
          }
          instance.$vs.loading.close()
          instance.type = personality[0].name;
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
ul {
  list-style-type: none;
  padding: 10px 0;
}

.results > ul {
  list-style-type: circle;
}

li {
  padding: 3px;
}

.intro {
  padding: 10px;
}

.intro p {
  padding: 3px;
}

.question {
  padding: 5px 10%;
  display: block;
  text-align: left;
}

.question .con-vs-radio {
  justify-content: left;
}

.qno {
  font-weight: bold;
}

.survey p {
  padding: 3px;
}

.description {
  display: flex;
  padding: 3px;
}

.submit {
  padding: 20px 0;
}

@media screen and (min-width: 1024px) {
  .question {
    padding: 5px 30%;
  }
}

/* Customize the label (the container) */
.container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 5px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #eee;
  border-radius: 50%;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #2196F3;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/Questions.vue